import _ from 'lodash'
import { set } from 'lodash'
import { Modal } from 'bootstrap-vue'
import { FORM_ERROR, FormApi } from 'final-form'
import { Component, Watch } from 'vue-property-decorator'
import { faExclamationTriangle, faSpinner } from '@fortawesome/free-solid-svg-icons'

import { Movement, MovementTypes, Item } from '@skinsoft/types'
import { itemSelectors, movementSelectors } from '@skinsoft/selectors'
import { fetch } from '@skinsoft/network'
import { ACCESSORY_TYPES_FOR_SEARCH, CONTAINER_TYPES_FOR_SEARCH } from '@skinsoft/data-store/src/data-stores-entity-names'
import {
    ItemDataStore,
    LocationDataStore,
    MovementDataStore,
} from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { ASK_FOR_MISSING_LOCATION } from '@skinsoft/bus'
import { CloseForm, Values } from './close-form'

declare const ITEM_SEARCH_TYPES: string[]

@Component({
    components: {
        sCloseForm: CloseForm,
    },
    props: ['committedItems', 'movement'],
    template: require('./close-movement-modal.html'),
})
export class CloseMovementModal extends ReactiveVue {
    public committedItems: Array<Item['id']>;
    public movement: Movement;
    public loadingIcon = faSpinner;
    public warningIcon = faExclamationTriangle;
    public canBeClosed = false;
    public initialValues: Values
    public isMounted = false;

    public $locationDataStore: LocationDataStore;
    public $movementDataStore: MovementDataStore;
    public $itemDataStore: ItemDataStore
    public $refs: {
        modal: Modal;
    };
    public movementSelectors = movementSelectors;

    public mounted() {
        this.initialValues = {
            location: null as any,
            permanentLocation: false,
            usePermanentLocItemAsDestination: this.movement?.workflowSchema?.usePermanentLocationForDestination,
        };
    }

    public open() {
        this.$refs.modal.show();
    }

    public onHide() {
        this.canBeClosed = false;
        this.isMounted = false;
    }

    public onShow() {
        this.isMounted = true;
    }

    public async onSubmit(values, form: FormApi) {
        let locationId;

        if (movementSelectors.movementType(this.movement) === MovementTypes.SIMPLE) {
            if(values.usePermanentLocItemAsDestination) {
                const itemsIds = this.movement.workflowSchema.linkableItems.map(linkableItem => linkableItem.linkableItem)
                const itemsToCheck = await this.$itemDataStore.searchAll('', undefined, undefined, _.union(ITEM_SEARCH_TYPES, CONTAINER_TYPES_FOR_SEARCH, ACCESSORY_TYPES_FOR_SEARCH), undefined, undefined, itemsIds).toPromise()

                let itemsWithNoPermLoc: Array<Item> = []
                for(const item of itemsToCheck.allData) {
                    if(!itemSelectors.permanentLocation(item as Item)) {
                        itemsWithNoPermLoc.push(item as Item)
                    }
                }

                if(itemsWithNoPermLoc.length > 0) {
                    this.emitOnBus(ASK_FOR_MISSING_LOCATION, itemsWithNoPermLoc.map(item => item.id))
                    return {
                        'noPermanentLocation': {
                            message: 'entity.closeMovement.error.itemsWithoutPermanentLocation',
                            params: [this.$t('entity.closeMovement.form.usePermanentLocItemAsDestination.label')]
                        },
                    }
                }
            } else {
                locationId = values.location?.id
                if(!locationId) {
                    return {
                        'noDestination': {
                            message: 'entity.closeMovement.error.noDestination',
                        },
                    }
                }
            }
        }

        try {
            await this.$movementDataStore.closeMovement(
                this.movement.id,
                locationId,
                values.permanentLocation,
                values.usePermanentLocItemAsDestination
            );

            this.$emit('close');
            (this.$refs.modal as any).hide();
        } catch (error) {
            const formErrors = {};
            if (fetch.isNetworkError(error as Error)) {
                formErrors[FORM_ERROR] = {
                    message: 'entity.closeMovement.error.network',
                }
            }

            if (this.movement.workflowSchema.linkableItems.some(item => !item.arrivalLocation)) {
                set(formErrors, 'noLocation', { message: 'entity.closeMovement.error.noItemLocation' })
            }
            return formErrors
        }
    }

    @Watch('isMounted')
    private onMountedChange(value: boolean) {
        this.$emit('mounted', value);
    }
}
